import React from "react";

const Controls: React.FC<{ children: any }> = ({ children }) => {
  return <div>{children}</div>;
};

export default Controls;
